import { ActionType } from 'app/store/actionTypes';
import { ActionsUnion, createAction } from 'app/store/helpers';

export const PaymentActions = {
  setPaymentCustomerId: (customerId: string) =>
    createAction(ActionType.SET_PAYMENT_CUSTOMER_ID, customerId),
};

export type PaymentActionsType = ActionsUnion<typeof PaymentActions>;
